import { ModalWindow, UIHeading2 } from '@cian/ui-kit';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import * as styles from './FeedbackChatbotModal.css';
import { closeFeedbackChatbotModal, setFeedback, setFeedbackComment } from '../../actions/feedbackChatbotModal';
import { feedbackChatbotModalSelector } from '../../selectors/feedbackChatbotModalSelector';
import { FeedbackComment } from '../FeedbackComment/FeedbackComment';
import { Rating } from '../Rating/Rating';

type TCFeedbackChatbotModalProps = {
  showFeedbackComment: boolean;
  setShowFeedbackComment: (show: boolean) => void;
  onCancel(): void;
};

export const FeedbackChatbotModal: React.VFC<TCFeedbackChatbotModalProps> = ({
  showFeedbackComment,
  setShowFeedbackComment,
  onCancel,
}) => {
  const dispatch = useDispatch();
  const { rating } = useSelector(feedbackChatbotModalSelector);

  const modalRef = React.useRef<HTMLDivElement>(null);

  //Убрать после того как элемент нового модального окна добавят в ui-kit
  React.useEffect(() => {
    /* istanbul ignore next */
    if (modalRef.current) {
      const parentElement = modalRef.current.closest('div[role="dialog"]');
      if (parentElement) {
        parentElement.classList.add(styles['modal-container']);

        const closeButton = parentElement.querySelector('div[role="button"][aria-label="Закрыть"]');
        if (closeButton) {
          closeButton.classList.add(styles['close-button']);

          const closeButtonParent = closeButton.parentElement;
          if (closeButtonParent) {
            closeButtonParent.classList.add(styles['header-content']);
          }
        }
      }
    }
  }, []);

  React.useEffect(() => {
    setShowFeedbackComment(false);

    if (rating > 0) {
      const timer = setTimeout(() => {
        setShowFeedbackComment(true);
      }, 3000);

      return () => clearTimeout(timer);
    }

    return () => {};
  }, [rating, dispatch]);

  const handleStarClick = (index: number) => {
    dispatch(setFeedback(index + 1));
  };

  const handleSetComment = (comment: string) => {
    const formattedComment = comment === '' ? null : comment;
    dispatch(setFeedbackComment(formattedComment));
    dispatch(closeFeedbackChatbotModal());
  };

  return (
    <ModalWindow open={true} onClose={onCancel} width={640}>
      <div ref={modalRef} data-name="FeedbackChatbotModal">
        <div className={styles['content']}>
          <img src="https://images.cdn-cian.ru/imgmobile/chats/cian-chat-bot/avatar.jpg" height={60} width={60} />
          <div className={styles['title']}>
            <UIHeading2 textAlign="center">У меня получается вам помогать?</UIHeading2>
          </div>
          {showFeedbackComment ? (
            <FeedbackComment setComment={handleSetComment} />
          ) : (
            <Rating rating={rating} onStarClick={handleStarClick} />
          )}
        </div>
      </div>
    </ModalWindow>
  );
};
